export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd252020',
  loginNameProject: 'BIODIGESTOR SAMAE/SC',
  sideNameProject: 'BIO SAMAE - SBS/SC'
}



// WEBPACK FOOTER //
// ./src/config/index.js